module.exports = __webpack_public_path__ + "img/img-14-2.4481c45d.png";